import BaseModel from "./Abstracts/BaseModel";
import CoursePage from "./CoursePage";


export default class Module extends BaseModel{
    constructor(data) {
        super()
        this.$dirty = false
        this.id = null
        this.title = ''
        this.subTitle = ''
        this.description = ''
        this.position = 99
        this.imageAlt = ''
        this.status = ''
        this.pages = {data: []}
        this.image = {data: []}
        this.tokens = {}
        this.urls = {
            viewPage: ''
        }
        this.seoMeta = {
            data: {
                title: '',
                description: '',
            }
        }
        this._isNewRecord = false

        this._skipKeys.push('_isNewRecord')
        this._skipKeys.push('pages')
        this._skipKeys.push('urls')
        this._skipKeys.push('tokens')
        this._skipKeys.push('image')
        this._skipKeys.push('seoMeta')

        this.setData(data)
        this.setInitialized()

        this._getAdditionalFormData = function() {
            return {
                metaTitle: this.seoMeta.data.title,
                metaDescription: this.seoMeta.data.description,
            }
        }
    }

    setData(data) {
        super.setData(data)

        if (!data) {
            return;
        }
        this.pages.data = data.pages ? data.pages.data.map(page => new CoursePage(page)) : [];
    }

    getFormData() {
        const formData = super.getFormData()
        formData.append('image', JSON.stringify(this.image))

        return formData
    }

    setImage(fileInfo){
        const data = {
            src: fileInfo.url,
            title: fileInfo.title,
            description: fileInfo.description,
            fID: fileInfo.fID,
        }
        this.image = { ...this.image, data };
    }

    setIsNewRecord() {
        this._isNewRecord = true
        this.id = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        )
    }

    isNewRecord() {
        return this._isNewRecord
    }
}
